// Stripe product/price mapping for AussiBooks tiers

/** Founding Member offer expires on this date (UTC). After this date, only the regular lifetime tier is available. */
export const FOUNDING_OFFER_EXPIRES = new Date("2026-08-20T00:00:00Z");

export const TIERS = {
  founding_member: {
    price_id: "price_1T4Gnn2EU1GzmOLK5ZgjUlzH",
    product_id: "prod_U2LUy5i7MhbvxD",
    name: "Founding Member",
    price: "$149",
    interval: "once",
    mode: "payment" as const,
    badge: "Launch Exclusive",
    features: [
      "Everything in Pro — forever",
      "One-time payment, lifetime access",
      "Launch cohort exclusive pricing",
      "Lifetime priority support",
    ],
  },
  monthly: {
    price_id: "price_1T0xGZ2EU1GzmOLKBYFoVaF0",
    product_id: "prod_Tyv6ODVtCBtOpF",
    name: "Pro Monthly",
    price: "$4.50",
    interval: "month",
    mode: "subscription" as const,
    features: [
      "Live bank sync via Basiq",
      "Automatic transaction import",
      "Priority support",
    ],
  },
  annual: {
    price_id: "price_1T0zJL2EU1GzmOLK01ubAes7",
    product_id: "prod_TyxDTg8catrske",
    name: "Pro Annual",
    price: "$44",
    interval: "year",
    mode: "subscription" as const,
    badge: "Save 18%",
    features: [
      "Everything in Monthly",
      "Save vs monthly billing",
      "Priority support",
    ],
  },
  lifetime: {
    price_id: "price_1T0zJl2EU1GzmOLKNCl8X91A",
    product_id: "prod_TyxEwJypBl2yYT",
    name: "Premium Lifetime",
    price: "$176",
    interval: "once",
    mode: "payment" as const,
    badge: "Best Value",
    features: [
      "Everything in Pro",
      "One-time payment, forever access",
      "Lifetime priority support",
    ],
  },
} as const;

export type TierKey = keyof typeof TIERS;

// Map product IDs back to tier keys for check-subscription
export const PRODUCT_TO_TIER: Record<string, TierKey> = Object.fromEntries(
  Object.entries(TIERS).map(([key, tier]) => [tier.product_id, key as TierKey])
) as Record<string, TierKey>;

export interface SubscriptionState {
  subscribed: boolean;
  productId: string | null;
  subscriptionEnd: string | null;
  loading: boolean;
  tier: TierKey | null;
  isFoundingMember: boolean;
  foundingOfferActive: boolean;
}

const CACHE_KEY = 'aussibooks_sub_cache';

function getCachedState(): SubscriptionState {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) {
      const cached = JSON.parse(raw);
      return { ...cached, loading: true };
    }
  } catch {}
  return {
    subscribed: false,
    productId: null,
    subscriptionEnd: null,
    loading: true,
    tier: null,
    isFoundingMember: false,
    foundingOfferActive: new Date() < FOUNDING_OFFER_EXPIRES,
  };
}

export function cacheSubscriptionState(state: SubscriptionState) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ ...state, loading: true }));
  } catch {}
}

export const DEFAULT_SUBSCRIPTION_STATE: SubscriptionState = getCachedState();
